import * as yup from 'yup'

export const ExcludedCommoditiesSchema = yup.object({
  alcohol: yup.boolean(),
  babyFood: yup.boolean(),
  cosmetic: yup.boolean(),
  electronic: yup.boolean(),
  garment: yup.boolean(),
  jewelry: yup.boolean(),
  meat: yup.boolean(),
  medication: yup.boolean(),
  metal: yup.boolean(),
  seafood: yup.boolean(),
  tobacco: yup.boolean(),
})

export type TExcludedCommoditiesSchema = yup.InferType<typeof ExcludedCommoditiesSchema>
